/* raw layout hash: _connector-registration-layout:72619edc56e67692163f4de3317d42df704812067af7fedf6327a436be66e6b2 */
import React from 'react';
import PublicLayout from './PublicLayout.jsx';

export default function ConnectorRegistrationLayout() {
  return <PublicLayout />;
}
